import { Controller } from "@hotwired/stimulus"
import api from "../../application/wv/api"
import { callKarrotBridgeSafely } from "../../lib/karrot_bridge_utils"

export default class extends Controller {
    static targets = ["dialog"]
    static values = {id: Number}

    connect() {
        console.log("Feedback Cancel controller connected!")
    }

    show(event) {
        event.preventDefault()
        this.dialogTarget.style.display = "flex"
    }

    close() {
        this.dialogTarget.style.display = "none"
    }

    async submit() {
        this.dialogTarget.style.display = "none"
        await api.feedbacks.cancel(this.idValue)
        callKarrotBridgeSafely(
            (bridge) => {
                bridge.emitToStream({stream: {eventName: "feedback:cancel", data: JSON.stringify({})}})
                bridge.closeRouter({})
            },
            { fallback: () => window.history.back() }
        )
    }
}
